function cov_22bwxgwi0v() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/PhoneFilled.tsx";
  var hash = "d78582bf61f91dcf660da2ad55c8afc6b2354d19";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/PhoneFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 52
        },
        end: {
          line: 6,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "d78582bf61f91dcf660da2ad55c8afc6b2354d19"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_22bwxgwi0v = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_22bwxgwi0v();
var Icon = (cov_22bwxgwi0v().s[0]++, {
  name: 'phone-filled',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.73635 4.7732C5.02641 4.65281 5.33739 4.59082 5.65148 4.59082C5.96557 4.59082 6.27655 4.65281 6.56661 4.7732C6.85621 4.89341 7.11929 5.06949 7.34082 5.29139L7.34191 5.29248L9.16112 7.10911C9.52237 7.47379 9.757 7.94481 9.83054 8.45282C9.90321 8.9548 9.81479 9.46676 9.5782 9.91511L9.00884 11.0403C9.01143 11.0562 9.01397 11.0713 9.01692 11.0888C9.01861 11.0989 9.02043 11.1097 9.02247 11.1219C9.02815 11.1559 9.03511 11.1982 9.04153 11.2425C9.04335 11.255 9.04506 11.2672 9.04665 11.279L12.6275 14.8623C12.6497 14.8518 12.6722 14.842 12.6949 14.8329L14.05 14.2886C14.4847 14.0721 14.9759 13.9928 15.4579 14.0626C15.9683 14.1365 16.4412 14.3735 16.8058 14.7383L16.8068 14.7393L18.6205 16.5582L18.622 16.5597C18.8437 16.7812 19.0197 17.0441 19.1398 17.3335C19.2602 17.6236 19.3222 17.9346 19.3222 18.2487C19.3222 18.5627 19.2602 18.8737 19.1398 19.1638C19.0195 19.4535 18.8433 19.7167 18.6213 19.9383L18.6205 19.9391L17.4696 21.09C16.9641 21.6015 16.317 21.9499 15.6116 22.0901C14.905 22.2306 14.1725 22.1558 13.509 21.8754C8.33303 19.6989 4.21548 15.5817 2.03851 10.4061C1.75661 9.74512 1.67901 9.01487 1.81576 8.30937C1.95271 7.60287 2.29832 6.95365 2.80796 6.44556L3.96184 5.29168C4.18344 5.06964 4.44662 4.89346 4.73635 4.7732ZM8.99362 10.9283L8.99371 10.9302L8.99362 10.9283Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.2992 2.19698C11.7039 1.74307 13.1969 1.63284 14.653 1.87558C16.0143 2.10038 17.3051 2.63687 18.4248 3.44311C19.9907 4.55929 21.1647 6.14092 21.7797 7.96296C22.3951 9.78612 22.4194 11.757 21.8492 13.5948C21.6446 14.2541 20.9443 14.6228 20.2849 14.4182C19.6256 14.2136 19.2569 13.5133 19.4615 12.8539C19.8757 11.5188 19.858 10.087 19.411 8.76249C18.9639 7.43799 18.1102 6.28835 16.9716 5.47738L16.9659 5.47332C16.1581 4.89116 15.2265 4.5039 14.2441 4.34191L14.2419 4.34155C13.1804 4.16459 12.092 4.24495 11.068 4.57585C10.4111 4.78814 9.70644 4.4277 9.49416 3.77079C9.28188 3.11388 9.64231 2.40927 10.2992 2.19698Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.4222 6.36638C13.3336 6.22556 14.2663 6.36228 15.0989 6.75875C15.9307 7.15478 16.6241 7.79166 17.0893 8.58671C17.3015 8.94648 17.4611 9.33481 17.5631 9.73984C17.684 10.2187 17.7279 10.7137 17.6933 11.2063C17.6448 11.895 17.0472 12.414 16.3586 12.3655C15.6699 12.317 15.151 11.7195 15.1994 11.0308C15.2155 10.8027 15.1951 10.5735 15.1392 10.3517C15.0953 10.1777 15.0266 10.0102 14.9353 9.85571L14.9322 9.85048C14.7202 9.48747 14.4038 9.19668 14.0242 9.01593C13.6446 8.83519 13.2194 8.77287 12.8039 8.83706C12.1217 8.94248 11.4831 8.47486 11.3777 7.7926C11.2723 7.11034 11.7399 6.4718 12.4222 6.36638Z\" fill=\"currentColor\"/>"
});
export default Icon;